import React from 'react'
import { ReactComponent } from './ouvrage.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface OuvrageProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', OuvrageProps>

export const OuvrageIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
